__turbopack_context__.v({
  "button": "style-module-scss-module__qwssjG__button",
  "note": "style-module-scss-module__qwssjG__note",
  "root": "style-module-scss-module__qwssjG__root",
  "subtitle": "style-module-scss-module__qwssjG__subtitle",
  "title": "style-module-scss-module__qwssjG__title",
});
